import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import KeyStore from 'utils/KeyStore';

const TimeClockProtectedRoute = ({ children, path, ...rest }) => {
    const isTimeclockDomain = window.location.hostname === new URL(process.env.REACT_APP_TIMECLOCK_HTTP).hostname;

    const isAllowedTimeclockHost = isTimeclockDomain;

    if (!isAllowedTimeclockHost) {
        return <Redirect to={{ pathname: '/' }} />;
    }

    // Global KeyStore validation: always check first on allowed host
    if (!new KeyStore().exists()) {
        return <Redirect to={{ pathname: '/login' }} />;
    }

    return (
        <Route
            {...rest}
            path={path}
            render={
                () => (
                    <>
                        <Helmet defer={false}>
                            <title>{rest?.title || 'Automatrix DMS'}</title>
                            <meta name="description" content={rest?.description || 'Automatrix dmspro App'} />
                        </Helmet>
                        {children}
                    </>
                )
            }
            onEnter
        />
    );
};

TimeClockProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

TimeClockProtectedRoute.defaultProps = {
    path: '/',
};

export default TimeClockProtectedRoute;
